import { ApiParamFundStatus, ApiParamPortfolio, ApiParamPosition, ApiParamRule, WweSimulatedPerformanceUserInputs } from '@ddt-web/domain';

/**
 * @description AnalysisParams: used to construct data-portfolio-analysis-service API calls.
 */
export class AnalysisParams {
	constructor(
		public readonly analysisParamsArray: Array<PortfolioAnalysisParams>,
		public readonly benchmark?: ApiParamPortfolio,
		public readonly riskBenchmark?: ApiParamPortfolio,
		public readonly simulatedPerformanceUserInputs?: WweSimulatedPerformanceUserInputs,
		public readonly configs?: any[]
	) { }
}

export class PortfolioAnalysisParams {
	constructor(
		public readonly uniqueId?: string,
		public readonly portfolioId?: number | string,
		public readonly positions?: ApiParamPosition[],
		public description?: string,
		public currency?: string,
		public statuses?: ApiParamFundStatus[],
		public rules?: Map<string, ApiParamRule>,
		public readonly configs?: any[]
	) { }
}
